import { removeEmptyKeys } from 'client/contexts/Tracking/utils'

function buildCustomerDataInputsToBodyRequest({ name, last, email, phone, address, city }) {
  return {
    first_name: name,
    last_name: last,
    email,
    phone,
    physical_address: address,
    physical_city: city,
  }
}

function buildHolderInputsToBodyRequest({ holders }) {
  return {
    holders: holders.map(holder => ({
      first_name: holder.name,
      last_name: holder.last,
      email: holder.email,
    })),
  }
}

function buildSpecialRequestsInputsToBodyRequest(checkoutInputs) {
  const specialRequests = [
    checkoutInputs.bedPreference,
    checkoutInputs.checkInPreference,
    checkoutInputs.smokersRoomPreference,
    checkoutInputs.highRoomPreference,
    checkoutInputs.cradleRoomPreference,
    checkoutInputs.writeSpecialRequests,
  ]
    .filter(r => r)
    .join(' - ')
    .trim()

  if (!specialRequests) {
    return {}
  }

  return { requests: specialRequests }
}

function buildInsurancesInputsToBodyRequest(checkoutInputs) {
  const { boardsWihtInsurance = [] } = checkoutInputs

  if (boardsWihtInsurance.length === 0) {
    return {}
  }

  return { insurance_ids: boardsWihtInsurance.map(board => board.availabilityId) }
}

function buildUpdatePurchaseToBodyRequest(params) {
  return {
    purchase_id: params.purchaseId,
    property_id: params.propertyId,
    session_id: params?.sessionId,
    lang: params.language,
    market: params.market,
    source: 'web',
    ...(params.context && { context: params.context }),
    ...buildCustomerDataInputsToBodyRequest(params),
    ...buildHolderInputsToBodyRequest(params),
    ...buildSpecialRequestsInputsToBodyRequest(params),
    ...buildInsurancesInputsToBodyRequest(params),
  }
}

function buildUpdateCustomerDataToBodyRequest(params) {
  return {
    purchase_id: params.purchaseId,
    property_id: params.propertyId,
    session_id: params?.sessionId,
    lang: params.language,
    market: params.market,
    source: 'web',
    context: params.context,
    ...buildCustomerDataInputsToBodyRequest(params),
    ...buildHolderInputsToBodyRequest(params),
    ...buildSpecialRequestsInputsToBodyRequest(params),
    ...buildInsurancesInputsToBodyRequest(params),
  }
}

function buildCreatePurchaseRequest({ availabilityIds, insuranceIds, context, market }) {
  return removeEmptyKeys({
    id_availabilities: availabilityIds,
    insurance_ids: insuranceIds,
    context,
    market,
  })
}

function buildPurchaseByIdRequest({ purchaseId }) {
  return {
    purchase_id: purchaseId,
  }
}

function buildPurchasePaymentMethodByIdRequest({
  context,
  domain,
  language,
  market,
  paymentProvider,
  purchaseId,
}) {
  return {
    context,
    domain,
    language,
    market,
    payment_provider: paymentProvider,
    purchase_id: purchaseId,
  }
}

function buildConfirmPurchaseBodyRequest({
  purchaseId,
  language,
  isMobile,
  affiliateId,
  domain,
  affiliateData,
  sessionId,
  platform,
}) {
  return {
    domain,
    purchase_id: purchaseId,
    language,
    is_mobile: isMobile,
    affiliate_name: affiliateId,
    affiliate_data: affiliateData,
    browserAcceptHeader: 'application/json',
    browserColorDepth: `${window.screen.colorDepth}`,
    browserTimeZone: `${new Date().getTimezoneOffset()}`,
    browserJavaEnabled: false,
    browserScreenHeight: window.screen.height,
    browserScreenWidth: window.screen.width,
    session_id: sessionId,
    platform,
  }
}

function buildConfirmWorldlinePurchaseBodyRequest({
  purchaseId,
  language,
  isMobile,
  affiliateId,
  domain,
  sessionId,
  hostedTokenizationId,
  returnUrl,
  async,
  platform,
}) {
  return {
    domain,
    purchase_id: purchaseId,
    language,
    is_mobile: isMobile,
    affiliate_name: affiliateId,
    browserAcceptHeader: 'application/json',
    browserColorDepth: `${window.screen.colorDepth}`,
    browserTimeZone: `${new Date().getTimezoneOffset()}`,
    browserJavaEnabled: false,
    browserScreenHeight: window.screen.height,
    browserScreenWidth: window.screen.width,
    session_id: sessionId,
    Hostedtokenization: hostedTokenizationId,
    returnUrl,
    async,
    platform,
  }
}

function buildConfirmApplePayPurchaseBodyRequest({
  purchaseId,
  paymentData,
  ephemeralKey,
  publicKey,
  language,
  isMobile,
  affiliateId,
  domain,
  sessionId,
  platform,
}) {
  return {
    domain,
    purchase_id: purchaseId,
    payment_data: paymentData,
    ephemeral_key: ephemeralKey,
    public_key: publicKey,
    language,
    is_mobile: isMobile,
    affiliate_name: affiliateId,
    browserAcceptHeader: 'application/json',
    browserColorDepth: `${window.screen.colorDepth}`,
    browserTimeZone: `${new Date().getTimezoneOffset()}`,
    browserJavaEnabled: false,
    browserScreenHeight: window.screen.height,
    browserScreenWidth: window.screen.width,
    session_id: sessionId,
    platform,
  }
}

function buildCreateAliasBodyRequest({ cardHolderName, paytpvToken, purchaseId }) {
  return {
    username: cardHolderName,
    paytpvToken,
    purchase_id: purchaseId,
  }
}

export {
  buildCreateAliasBodyRequest,
  buildCreatePurchaseRequest,
  buildPurchaseByIdRequest,
  buildPurchasePaymentMethodByIdRequest,
  buildUpdateCustomerDataToBodyRequest,
  buildUpdatePurchaseToBodyRequest,
  buildConfirmPurchaseBodyRequest,
  buildConfirmWorldlinePurchaseBodyRequest,
  buildConfirmApplePayPurchaseBodyRequest,
}
